import { Component, DoCheck, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-violencia-genero',
  templateUrl: './violencia-genero.component.html',
  styleUrls: ['./violencia-genero.component.css']
})
export class ViolenciaGeneroComponent implements OnInit, DoCheck {
  @Input() formGroup: FormGroup;
  @Input() tiposViolencia: { id: number; descricao: string; tipoViolencia: string; ordem: number }[] = [];
  enviado = false;

  ngOnInit(): void {
    const controle = this.formGroup.get('descricaoReclamacao');
    const valor = controle.value;

    if (valor && typeof valor === 'object') {
      const descricao = valor.value || valor.descricaoReclamacao || valor.descricao || valor.texto || valor.text || '';
      controle.setValue(typeof descricao === 'string' ? descricao : '');
    }
  }

  ngDoCheck(): void {
    const telefone = this.vitima.get('telefone');
    if (telefone.value != null) {
      const formatado = this.formatarValorTelefone(String(telefone.value));
      if (telefone.value !== formatado) {
        telefone.setValue(formatado, { emitEvent: false });
      }
    }

    const estado = this.vitima.get('estado');
    if (estado.value != null) {
      const formatado = this.formatarValorEstado(String(estado.value));
      if (estado.value !== formatado) {
        estado.setValue(formatado, { emitEvent: false });
      }
    }
  }

  get cores(): { value: string; label: string }[] {
    const codigos = {
      BRANCA: 'BRANCA', PARDA: 'PARDA', PRETA: 'PRETA', AMARELA: 'AMARELA',
      INDIGENA: 'INDIGENA', OUTRA: 'OUTROS', OUTRO: 'OUTROS', OUTROS: 'OUTROS',
      PREFIRO_NAO_INFORMAR: 'NAO_INFORMAR', NAO_INFORMAR: 'NAO_INFORMAR'
    };
    const listaCorRaca: { id: number; label: string }[] = this.formGroup.get('listaCorRaca').value || [];
    const cores = listaCorRaca.map(cor => {
      const chave = cor.label.trim().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        .toUpperCase().replace(/[^A-Z]+/g, '_').replace(/^_|_$/g, '');
      const codigo = codigos[chave] || codigos[chave.replace(/^NEGRA_/, '')];
      return { value: codigo, label: cor.label };
    }).filter(cor => !!cor.value);

    if (!cores.some(cor => cor.value === 'OUTROS')) {
      cores.push({ value: 'OUTROS', label: 'Outros' });
    }
    if (!cores.some(cor => cor.value === 'NAO_INFORMAR')) {
      cores.push({ value: 'NAO_INFORMAR', label: 'Prefiro não informar' });
    }
    return cores;
  }

  trackByCorValue(_index: number, cor: { value: string; label: string }): string {
    return cor.value;
  }

  readonly cargos = [
    { value: 'MAGISTRADO', label: 'Magistrado (juiz, desembargador ou ministro)' },
    { value: 'SERVIDOR', label: 'Servidor do Poder Judiciário' },
    { value: 'NOTARIO_TABELIAO', label: 'Notários/Tabeliães/Registradores' },
    { value: 'NAO_OCUPA_CARGO', label: 'Não ocupa cargo no Poder Judiciário ou cartórios' },
    { value: 'DESCONHECIDO', label: 'Desconhecido' }
  ];
  readonly orgaos = [
    { value: 'TRIBUNAL_VARA_CARTORIO', label: 'Tribunal, Vara ou Cartório' },
    { value: 'DESCONHECIDO', label: 'Desconhecido' }
  ];
  readonly provas = [
    { value: 'DOCUMENTOS', label: 'Documentos' },
    { value: 'TESTEMUNHAS', label: 'Testemunhas' },
    { value: 'VIDEO_AUDIO', label: 'Arquivos de vídeo/áudio' },
    { value: 'OUTROS', label: 'Outros' }
  ];

  get violencia(): FormGroup {
    return this.formGroup.get('reclamacaoViolencia') as FormGroup;
  }

  get vitima(): FormGroup {
    return this.violencia.get('vitima') as FormGroup;
  }

  get agressor(): FormGroup {
    return this.violencia.get('agressor') as FormGroup;
  }

  get descricao(): FormControl {
    return this.formGroup.get('descricaoReclamacao') as FormControl;
  }

  get tipoSelecionados(): { tipoViolenciaId: number }[] {
    return this.violencia.get('tipos').value || [];
  }

  get provasSelecionadas(): { tipoProva: string }[] {
    return this.violencia.get('provas').value || [];
  }

  tipoSelecionado(id: number): boolean {
    return this.tipoSelecionados.some(tipo => tipo.tipoViolenciaId === id);
  }

  provaSelecionada(tipoProva: string): boolean {
    return this.provasSelecionadas.some(prova => prova.tipoProva === tipoProva);
  }

  selecionarTipo(id: number, selecionado: boolean): void {
    const tipos = this.tipoSelecionados.filter(tipo => tipo.tipoViolenciaId !== id);
    if (selecionado) {
      tipos.push({ tipoViolenciaId: id });
    }
    this.violencia.get('tipos').setValue(tipos);
  }

  selecionarProva(tipoProva: string, selecionado: boolean): void {
    const provas = this.provasSelecionadas.filter(prova => prova.tipoProva !== tipoProva);
    if (selecionado) {
      provas.push({ tipoProva });
    }
    this.violencia.get('provas').setValue(provas);
  }

  formatarTelefone(event: Event): void {
    const input = event.target as HTMLInputElement;
    const formatado = this.formatarValorTelefone(input.value);
    this.vitima.get('telefone').setValue(formatado, { emitEvent: false });
    input.value = formatado;
  }

  private formatarValorTelefone(valor: string): string {
    const digits = valor.replace(/\D/g, '').substring(0, 11);
    const ddd = digits.substring(0, 2);
    const celular = digits.length > 10;
    const tamanhoPrefixo = celular ? 7 : 6;
    const prefixo = digits.substring(2, tamanhoPrefixo);
    const sufixo = digits.substring(tamanhoPrefixo);
    return digits.length > 2
      ? `(${ddd}) ${prefixo}${sufixo ? `-${sufixo}` : ''}`
      : digits;
  }

  limitarEstado(event: Event): void {
    const input = event.target as HTMLInputElement;
    const estado = this.formatarValorEstado(input.value);
    this.vitima.get('estado').setValue(estado, { emitEvent: false });
    input.value = estado;
  }

  private formatarValorEstado(valor: string): string {
    return valor.replace(/[^a-zA-ZÀ-ÿ]/g, '').substring(0, 2).toUpperCase();
  }

  validar(): string {
    this.enviado = true;
    return this.validarMensagem;
  }

  get validarMensagem(): string {
    const campos = [
      this.vitima.get('cpf'), this.vitima.get('possuiDeficiencia'),
      this.agressor.get('agressorConhecido'), this.agressor.get('cargoAgressor'),
      this.agressor.get('orgaoAgressor'), this.violencia.get('processoAndamento'),
      this.violencia.get('exercicioFuncao'), this.violencia.get('fatoDependenciaOrgao'),
      this.violencia.get('riscoAtual'), this.violencia.get('denunciaOutroCanal'),
      this.violencia.get('desejaAudienciaPrevia'), this.violencia.get('inobservanciaProtocolo')
    ];
    const cpf = (this.vitima.get('cpf').value || '').replace(/\D/g, '');
    const nomeAgressor = this.agressor.get('nomeAgressor').value;
    const email = this.vitima.get('emailComunicacao').value;
    const telefone = (this.vitima.get('telefone').value || '').replace(/\D/g, '');
    const numeroProcesso = this.violencia.get('numeroProcesso').value || '';
    const emailInvalido = email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    const telefoneInvalido = telefone && telefone.length !== 10 && telefone.length !== 11;

    if (campos.some(campo => campo.value === null || campo.value === undefined || campo.value === '') ||
      cpf.length !== 11 || !nomeAgressor || emailInvalido || telefoneInvalido ||
      (this.vitima.get('estado').value && !/^[A-ZÀ-Ý]{1,2}$/.test(this.vitima.get('estado').value)) ||
      !this.tipoSelecionados.length ||
      (this.violencia.get('denunciaOutroCanal').value === true && !this.violencia.get('outroCanal').value) ||
      (this.violencia.get('processoAndamento').value === true &&
        !/^\d{7}-\d{2}\.\d{4}\.\d\.\d{2}\.\d{4}$/.test(numeroProcesso))) {
      return 'Preencha os campos obrigatórios da representação por violência.\n';
    }
    if (this.violencia.get('declaracaoVeracidade').value !== true ||
      this.violencia.get('autorizaCompartilhamento').value !== true) {
      return 'Confirme a declaração de veracidade e autorize o compartilhamento das informações.\n';
    }
    return '';
  }
}
